import { render, staticRenderFns } from "./header-account-button.vue?vue&type=template&id=1cedce8c&scoped=true&"
import script from "./header-account-button.vue?vue&type=script&lang=js&"
export * from "./header-account-button.vue?vue&type=script&lang=js&"
import style0 from "./header-account-button.vue?vue&type=style&index=0&id=1cedce8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cedce8c",
  null
  
)

export default component.exports